export default {

	getItem:function (key) {
		try {
			let data = localStorage.getItem(key);

			if (data){
				data = JSON.parse(data);
				if (data.time !== undefined && this.getTime() >= data.time) {
					this.removeItem(key);
					return null;
				} else {
					return data.data;
				}
			} else {
				return null;
			}

		} catch (e) {
			return null;
		}
	},

	setItem:function (key,data,time) {

		if (time && time > 0) {
			time = this.getTime() + time;
		} else {
			time = undefined;
		}

		return localStorage.setItem(key,JSON.stringify({
			data:data,
			time: time
		}));
	},

	removeItem: function (key) {
		return localStorage.removeItem(key);
	},

	getTime:function () {
		return parseInt(new Date().getTime()/1000);
	}


}
